import { useEffect, useState } from "react";
import { ArrowIcon, CopyIcon, GoToLogo, TickIcon } from "../../Assets/assets";
import { capitalizeFirstLetter } from "../../Utils/constants";

export function LocationCard(props) {
  return (
    <div
      onClick={props.onClick}
      className="display-flex inherit-parent-width padding-bottom-large"
      data-cy={`location-card-${props.data.documentId}`}
    >
      <div className="inherit-parent-width display-flex flex-justify-content-space-between">
        <div className="parent-width_-68px">
          {!props.loading ? (
            <>
              <div className="font-size-medium padding-bottom-small inherit-parent-width text-overflow-ellipsis font-color-tertiaryColor6">
                {props.data.location}
              </div>
              <div className="font-size-small font-color-tertiaryColor6 inherit-parent-width text-overflow-ellipsis white-space-nowrap">
                {`${props.data?.PCTNo?.toString().padStart(2, "0")}
                  - ${props.data.location}`}
              </div>
            </>
          ) : (
            <div className="inherit-parent-width">
              <div className="shimmer padding-large border-radius-default inherit-parent-width" />
            </div>
          )}
        </div>
        <div className="display-flex flex-align-items-center ">
          <div className="display-flex flex-align-items-center ">
            <ArrowIcon color="var(--tertiaryColor6)" />
          </div>
        </div>
      </div>
    </div>
  );
}

export const ShareCard = (props) => {
  const [showTick, setShowTick] = useState(false);
  const url =
    props.data.key === "admin"
      ? `${props.data.url}/locations/complaints/${props.complaintId}`
      : `${props.data.url}/complaints/${props.complaintId}`;

  useEffect(() => {
    const timer = setTimeout(() => {
      if (showTick) {
        setShowTick(false);
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [showTick]);

  return (
    <div
      className="padding-vertical-small"
      data-cy={`${props.data.key}-SHARE-CARD`}
    >
      <div className="font-color-tertiaryColor6 padding-bottom-small">
        {props.data.title}
      </div>
      <div className="flex-justify-content-space-between">
        <div className="text-overflow-ellipsis" style={{ fontWeight: 500 }}>
          {url}
        </div>
        <div style={{ gap: "16px", display: "flex", marginLeft: "16px" }}>
          {showTick ? (
            <div>
              <TickIcon height={16} width={16} color="var(--tertiaryColor6)" />
            </div>
          ) : (
            <div
              className="cursor-pointer"
              onClick={() => {
                setShowTick(true);
                navigator.clipboard.writeText(url);
              }}
            >
              <CopyIcon />
            </div>
          )}

          <div
            className="cursor-pointer"
            onClick={() => {
              if (navigator.share) {
                navigator
                  .share({
                    text: `Complaint Details (${capitalizeFirstLetter(
                      props.data.key
                    )})\nView details for complaint ID - ${
                      props.complaintId
                    }\n\n${url}
                    `
                  })
                  .catch((error) => console.error("Error sharing:", error));
              }
            }}
            title="Open link"
          >
            <GoToLogo />
          </div>
        </div>
      </div>
    </div>
  );
};
